// Homepage content slides above header, but mega menus need to be on top of everything
// Seemed this could not be achieved with CSS

import * as variables from '../variables.js';
import ViewportTracker from '../lib/ViewportTracker';
//@ts-ignore
var Debouncer = require('../lib/Debouncer.js');

const MegaMenu = () => {
	const hoverClass = 'megaMenu--isHover';

	document.querySelectorAll('.node--hasMegaMenu').forEach((menuNodeElem) => {
		const megaMenu: HTMLElement = menuNodeElem.querySelector('.megaMenu');

		const setPosition = (reset?: Boolean) => {
			if (ViewportTracker.above('mobileMenu', false)) {
				if (reset) {
					menuNodeElem.append(megaMenu);
					megaMenu.removeAttribute('style');
				}

				const rect = megaMenu.getBoundingClientRect();
				const megaMenuTop = Math.floor(rect.top + window.scrollY);
				const megaMenuRight = calculateRightEdgeDistance();

				const megaMenuTransform = (variables.megaMenuTransform as string).slice(0,-2);
				megaMenu.style.top = megaMenuTop - +megaMenuTransform + "px";
				megaMenu.style.right = megaMenuRight + "px";
				document.body.prepend(megaMenu);
			}
		}

		setPosition();
		var resizeDebouncer = new Debouncer(setPosition.bind(this, true));
		window.addEventListener('resize', resizeDebouncer.run, false);

		menuNodeElem.addEventListener('mouseenter', (evt: MouseEvent) => {
			megaMenu.classList.add(hoverClass);
		});

		menuNodeElem.addEventListener('mouseleave', (evt: MouseEvent) => {
			megaMenu.classList.remove(hoverClass);
		});

		megaMenu.addEventListener('mouseenter', (evt: MouseEvent) => {
			megaMenu.classList.add(hoverClass);
		});

		megaMenu.addEventListener('mouseleave', (evt: MouseEvent) => {
			megaMenu.classList.remove(hoverClass);
		});
	});
};

function calculateRightEdgeDistance() {
	// Query for the nav.menu element
	const navMenu = document.querySelector('nav.menu');
	if (!navMenu) {
	  console.error('nav.menu element not found');
	  return;
	}
  
	// Get the bounding client rectangle of the nav.menu element
	const navRect = navMenu.getBoundingClientRect();
  
	// Get the bounding client rectangle of the body element
	const bodyRect = document.body.getBoundingClientRect();
  
	// Calculate the distance in pixels between the right edge of nav.menu and the right edge of the body
	const distance = bodyRect.right - navRect.right;
  
	return distance;
  }

export default MegaMenu;